import type { JSX } from 'react';
import React from 'react';

import type { ITemplate } from '@feathr/blackbox';
import { TemplateClass } from '@feathr/blackbox';
import { PlaceholderImage } from '@feathr/components';
import CampaignChip from '@feathr/extender/components/CampaignChip';

import SelectOption from './SelectOption';
import type { ISelectOptionProps } from './SelectOptions.types';

import { contentWrapper } from './SelectOptions.css';

import noImg from 'images/no-img.png';

export function TemplateOption(props: Readonly<ISelectOptionProps<ITemplate>>): JSX.Element {
  const isBanner = [TemplateClass.Banner, TemplateClass.ReferralBanner].includes(props.data._cls);
  const shouldUsePlaceholder =
    isBanner && props.data.bannersnack_enabled && (!props.data.banner_hash || props.data.default);
  const isDefault = props.data.default === true;
  const hasCampaignParent = props.data.parent_kind === 'campaign';
  return (
    <SelectOption {...props}>
      <div style={{ display: 'flex' }}>
        <div className={contentWrapper}>
          {shouldUsePlaceholder ? (
            /* ITemplate's dimensions are optional; 0 is what the canvas already coerced
             * an undefined width/height to. */
            <PlaceholderImage
              height={props.data.height ?? 0}
              style={{ width: '100px' }}
              width={props.data.width ?? 0}
            />
          ) : (
            <img alt={''} src={`${props.data.thumbnail_url || noImg}`} style={{ width: '100px' }} />
          )}
        </div>
        <div className={contentWrapper}>
          <span>{props.data.name}</span>
        </div>
        <div className={contentWrapper}>
          {hasCampaignParent && isDefault && (
            <CampaignChip id={props.data.parent} linkToItem={false} />
          )}
        </div>
      </div>
    </SelectOption>
  );
}
